import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared.module';
import { CompetencyRoutingModule } from './competency.routing.module';
import { CompetencyComponent } from './competency/competency.component';
import { MatButtonModule, MatCheckboxModule, MatDatepickerModule, MatFormFieldModule, MatIconModule, MatInputModule, MatNativeDateModule, MatPaginatorModule, MatRadioModule, MatSelectModule, MatSortModule, MatStepperModule, MatTableModule, MatTabsModule } from '@angular/material';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CompetencyDashboardComponent } from './competency-dashboard/competency-dashboard.component';
import { StaffCompetencyListComponent } from './staff-competency-list/staff-competency-list.component';
import { MaterialsModule } from '../materials.module';
import { UtilityService } from '../services/utility.service';
import { EditCompModalComponent } from './edit-comp-modal/edit-comp-modal.component';



@NgModule({
  declarations: [CompetencyComponent,EditCompModalComponent, CompetencyDashboardComponent, StaffCompetencyListComponent],
  imports: [
    CommonModule,
    CompetencyRoutingModule,
    SharedModule,
    MaterialsModule,
    // MatTabsModule,
    // MatButtonModule,      
    // MatPaginatorModule,
    // MatInputModule,
    // MatIconModule,
    // MatFormFieldModule,
    // MatSelectModule,
    // MatTableModule,
    // MatStepperModule,
    // NgxMaterialTimepickerModule,
    // MatDatepickerModule,
    // MatNativeDateModule,
    // FormsModule,
    // ReactiveFormsModule,
    // MatRadioModule,
    // MatSortModule,
    // MatCheckboxModule,
    NgbModule
  ],
  providers: [
    UtilityService
  ]
})
export class CompetencyModule { }
